import { SectionHeading } from "@/components/Section";
import { Reveal } from "@/components/Reveal";
import { Phone, Mail } from "lucide-react";
import { BRAND } from "@/config";

const phoneHref = `tel:${BRAND.phone.replace(/[^+\d]/g, "")}`;

export default function PriceMatch() {
  return (
    <section data-testid="price-match" className="py-24 md:py-32 bg-forest-deep text-cream relative overflow-hidden">
      <div className="absolute inset-0 opacity-[0.05] noise-bg" />
      <div className="relative max-w-[1440px] mx-auto px-5 md:px-10 grid lg:grid-cols-2 gap-14 items-start">
        <div className="lg:sticky lg:top-28">
          <SectionHeading
            dark
            chapter="08 / Price Match & Beat"
            overline="Price Match · Price Beat"
            title={<>Already buying from another supplier? Let us review their price.</>}
            lead="Share a recent invoice or supplier quote with our team. We will review comparable products and work to match or beat eligible pricing wherever possible."
          />
          <div className="mt-8 grid grid-cols-3 gap-4 max-w-md">
            {["Match", "Beat", "Review"].map((t, i) => (
              <Reveal key={t} delay={i * 0.08} className="rounded-2xl bg-white/10 border border-white/15 p-4 text-center">
                <p className="font-display text-2xl text-butter-deep">{["=", "↓", "✓"][i]}</p>
                <p className="text-xs text-cream/70 mt-1">{t} eligible pricing</p>
              </Reveal>
            ))}
          </div>
        </div>

        <Reveal delay={0.1} className="rounded-3xl bg-forest border border-white/10 p-7 md:p-9" data-testid="price-match-statement-card">
          <p className="overline text-butter-deep">How It Works</p>
          <h3 className="font-display text-3xl text-butter tracking-tight mt-3">Send us a recent supplier invoice or quotation.</h3>
          <p className="text-cream/75 text-sm md:text-base leading-relaxed mt-5">
            We review the product specifications, pack sizes, quantities, delivery location and availability before confirming whether an item is eligible. Price matching may exclude clearance, promotional, membership or out-of-stock pricing.
          </p>
          <div className="flex flex-col sm:flex-row gap-3 mt-8">
            <a href={phoneHref} data-testid="home-price-match-phone" className="inline-flex items-center justify-center gap-2 rounded-full bg-butter-deep text-forest font-semibold px-6 py-3 text-sm hover:brightness-105 transition">
              <Phone className="h-4 w-4" /> Call Our Team
            </a>
            <a href={`mailto:${BRAND.email}?subject=Price%20Match%20Review`} data-testid="home-price-match-email" className="inline-flex items-center justify-center gap-2 rounded-full border border-white/30 text-cream font-semibold px-6 py-3 text-sm hover:bg-white hover:text-forest transition-colors">
              <Mail className="h-4 w-4" /> Email an Invoice
            </a>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
